var _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBitbucket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 231,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 231",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "108.63338%",
    x2: "46.926596%",
    y1: "13.818022%",
    y2: "78.776141%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m101.272088 152.561281h53.448624l12.901393-75.3195555h-80.5620266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.30813067.0006835c-2.42310093-.03125205-4.73600404 1.01057319-6.31827423 2.84600661s-2.27194244 4.2765956-1.88401252 6.66864601l34.81870728 211.37292988c.895485 5.339259 5.4953944 9.264746 10.9090413 9.309595h167.0395695c4.063354.052298 7.552433-2.878529 8.202287-6.889921l34.818707-213.75159244c.38793-2.39205042-.301742-4.83321259-1.884012-6.66864602-1.582271-1.83543342-3.895174-2.87725865-6.318275-2.84600661zm146.61587533 152.7675905h-53.314864l-14.4360243-75.4200265h80.6694903z",
    fill: "#2684ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.610824 77.2417255h-76.917048l-12.908296 75.3598565h-53.272329l-62.9023275 74.663219c1.9937259 1.723985 4.5356374 2.682649 7.1712751 2.704595h166.9472844c4.060112.052256 7.546408-2.876232 8.195743-6.884424z",
    fill: "url(#a)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBitbucket);
export default __webpack_public_path__ + "static/media/icon-bitbucket.e9e7136546d18011461148ed4671b075.svg";
export { ForwardRef as ReactComponent };